import { PaymentProviderConfigListPage } from "@/features/payment-provider-config/pages/PaymentProviderConfigListPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/payment-provider-config/")({
	beforeLoad({ context }) {
		if (
			!context.authAdapter.can({
				permissions: ["it.monitoring.payment_transaction"],
			})
		) {
			throw redirect({ to: "/403" });
		}
	},
	component: PaymentProviderConfigListPage,
});
